import React, { useState } from 'react';
import UserManagement from './UserManagement';
import NoticeManagement from './NoticeManagement';
import CustomerServiceManagement from './CustomerServiceManagement';
import CodeManagement from './CodeManagement';
import StdPriceManagement from './StdPriceManagement';
import SupplyManagement from './SupplyManagement';
import ComplexManagement from './ComplexManagement';
import ValidationManagement from './ValidationManagement';
import GeupjiManagement from './GeupjiManagement';
import CrawlingManagement from './CrawlingManagement';
import SentimentTimingManagement from './SentimentTimingManagement';
import MainScreenSettings from './MainScreenSettings';
import './AdminPage.css';

function AdminPage() {
  const [activeTab, setActiveTab] = useState('user');

  const tabs = [
    { id: 'user', label: '회원관리' },
    { id: 'notice', label: '공지사항관리' },
    { id: 'support', label: '고객센터관리' },
    { id: 'code', label: '코드관리' },
    { id: 'stdPrice', label: '기준가관리' },
    { id: 'supply', label: '공급/분양관리' },
    { id: 'complex', label: '단지관리' },
    { id: 'geupji', label: '지역/급지 관리' },
    { id: 'crawling', label: '크롤링설정' },
    { id: 'validation', label: '검증' },
    { id: 'sentimentTiming', label: '매수심리 타이밍' },
    { id: 'mainScreen', label: '메인화면설정' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'user':
        return <UserManagement />;
      case 'notice':
        return <NoticeManagement />;
      case 'support':
        return <CustomerServiceManagement />;
      case 'code':
        return <CodeManagement />;
      case 'stdPrice':
        return <StdPriceManagement />;
      case 'supply':
        return <SupplyManagement />;
      case 'complex':
        return <ComplexManagement />;
      case 'geupji':
        return <GeupjiManagement />;
      case 'crawling':
        return <CrawlingManagement />;
      case 'validation':
        return <ValidationManagement />;
      case 'sentimentTiming':
        return <SentimentTimingManagement />;
      case 'mainScreen':
        return <MainScreenSettings />;
      default:
        return <div className="tab-content-placeholder">선택된 탭이 없습니다.</div>;
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="admin-content">
        {renderTabContent()}
      </div>
    </div>
  );
}

export default AdminPage;
